import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
export const NavMenu = ({ CoockieData, Udata }) => {
    const [isActive, setActive] = useState(false);
    const Location = useLocation();
    const [classVal, setClassVal] = useState("");
    const [isCustomerLogin, setIsCustomerLogin] = useState();
    const [customerName, setCustomerName] = useState();
    const [UserName, setUserName] = useState("Sign In");
    const [Accounts, setAccounts] = useState("Accounts");
    const [isScrolled, setIsScrolled] = useState(false);
    const [IsLogin, setIsLogin] = useState(false);


    const isRetailUser = CoockieData?.config?.IsShowHeaders;

    // Handle localStorage clearing for retail users
    useEffect(() => {
        if (!isRetailUser && isRetailUser !== undefined) {
            window.localStorage.removeItem("smc-csp-customer-name");
            window.localStorage.removeItem("smc-csp-token");
        }
    }, [isRetailUser]);

    // Retrieve customer and token data from localStorage
    useEffect(() => {
        const custName = window.localStorage.getItem("smc-csp-customer-name");
        const custToken = window.localStorage.getItem("smc-csp-token");
        setCustomerName(custName);
        setIsCustomerLogin(Boolean(custToken));
        const path = window.location.pathname; // "/epartner"
       // console.log(path);
    }, []);

    // Update `userName` dynamically based on multiple conditions
    useEffect(() => {
        if (Udata?.userName || customerName) {
            if (customerName) {
                setUserName(customerName); // Combine both names
                setIsLogin(true)
                setAccounts("Dashboard")
            } else {
                setUserName(Udata.userName);
                setAccounts("Dashboard")
                setIsLogin(true)
            }
        } else {
            setUserName("Sign In"); // Default fallback
            setIsLogin(false)
        } 

    }, [Udata.userName, customerName]);

    // Reset active state on location change
    useEffect(() => {
        setActive(false);
    }, [Location]);

    // Handle scroll event for desktop
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        };

        if (window.innerWidth >= 768) {
            window.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (window.innerWidth >= 768) {
                window.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);

    return (
        <React.Fragment>
            <header className={isScrolled ? `header scrolled ${classVal}` : `header ${classVal}`}>
                <nav className="navbar navbar-expand-lg navbar-light" aria-label="Offcanvas navbar large">
                    <div className="container-fluid d-block">
                        <div className="wrapper">
                            <div className="header-item-left">
                                <a className="navbar-brand" href="/">
                                    <img src='https://www.smcinsurance.com/img/smclogo.png' alt="logo" title="SMC Insurance" />
                                </a>
                            </div>
                            <div className="header-item-center">
                                <div className="offcanvas offcanvas-start text-bg-light" tabIndex="-1" id="offcanvasNavbar2" aria-labelledby="offcanvasNavbar2Label">
                                    <div className="offcanvas-header">
                                        <a className="navbar-brand" href="/">
                                            <img src='https://www.smcinsurance.com/img/smclogo.png'alt="logo" title="SMC Insurance" />
                                        </a>
                                        <button type="button" className="btn-close btn-close-black" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    </div>
                                    <div class="offcanvas-body">
                                        {(Udata.roleID !== 29 && Udata.roleID !== 32) &&
                                            <ul class="navbar-nav flex-grow-1 pe-3" id="WithPrevilage">
                                                <li class="nav-item dropdown">
                                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        General Insurance <i class="fas fa-angle-down"></i>
                                                    </a>
                                                    <div class="menu-subs dropdown-menu menu-small">
                                                        <div class="OurProduct">
                                                            <ul>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/motor-insurance">
                                                                        Motor Insurance
                                                                    </a>
                                                                </li>

                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/motor-insurance/car-insurance">
                                                                        Car Insurance
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/motor-insurance/two-wheeler-insurance">
                                                                        Two Wheeler Insurance
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/motor-insurance/commercial-vehicle-insurance">
                                                                        Commercial Vehicle Insurance
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/motor-insurance/two-wheeler-insurance/e-bike-insurance">
                                                                        E-Bike Insurance
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/health-insurance">
                                                                        Health Insurance
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li class="nav-item dropdown">
                                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        Life Insurance <i class="fas fa-angle-down"></i>
                                                    </a>
                                                    <div class="menu-subs dropdown-menu menu-small">
                                                        <div class="OurProduct">
                                                            <ul>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/life-insurance">
                                                                        Life Insurance
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/life-insurance/term-insurance">
                                                                        Term Insurance
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/life-insurance/pension-plans">
                                                                        Pension Plans
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/life-insurance/whole-life-insurance">
                                                                        Whole Life Insurance
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/life-insurance/ulip-plans">
                                                                        Unit Linked Insurance Plan
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li class="nav-item dropdown">
                                                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        Insurance Article <i class="fas fa-angle-down"></i>
                                                    </a>
                                                    <div class="menu-subs dropdown-menu menu-small">
                                                        <div class="OurProduct">
                                                            <ul>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/articles">
                                                                        Articles
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/insurance-videos">
                                                                        Videos
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/magazine">
                                                                        Magazine
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/thebrainery">
                                                                        The Brainery
                                                                    </a>
                                                                </li>
                                                                <li itemprop="name">
                                                                    <a itemprop="url" href="/ebook-section">
                                                                        E-Book
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>

                                        }

                                        <ul class="navbar-nav justify-content-end flex-grow-1 pe-3" id="HideWithAFF">
                                            {(Udata.roleID !== 29 && Udata.roleID !== 32) &&
                                                <li itemprop="name" class="IsDisabledEle">
                                                    <a itemprop="url" href="/epartner" class="nav-link">
                                                        Become a Sales Partner
                                                    </a>
                                                </li>
                                            }
                                            <li itemprop="name">
                                                <a itemprop="url" href="/claims" class="nav-link">
                                                    Claim
                                                </a>
                                            </li>

                                            {(Udata.roleID !== 29 && Udata.roleID !== 32) &&
                                                <li itemprop="name" class="IsDisabledAssureEle">
                                                    <a itemprop="url" href="https://ha.smcinsurance.com/" rel="nofollow" target="_blank" class="nav-link">
                                                        SMC Assure
                                                    </a>
                                                </li>
                                            }
                                        </ul>

                                    </div>
                                </div>
                            </div>

                            {(Udata.roleID !== 29 && Udata.roleID !== 32) &&
                                <div class="header-item-right navbar-nav">
                                    <div class="nav-item dropdown">
                                        <a class={!IsLogin ? "nav-link" : "nav-link DashUI"} href={customerName ? "/customers/dashboard" : Udata?.userName ? "/myaccount" : "javascript:void(0)" } >
                                            <div class="UserAccount">
                                                {IsLogin && <div class="UserAccountIcon"><img src={require("./img/profile-pic.jpg").default} height="50" width="50" alt="profile pic" title="profile pic" /></div>}
                                                <div class="UserAccountStatus">
                                                    <p>Hello, <span>{UserName}</span></p>
                                                    {UserName && <span class={UserName !== "Sign In" ? "tooltiptext tttext" : "tooltiptext"} id="tooltiptext">{UserName ? UserName : "Sign In"}</span>}
                                                    <h5><span id="MyAccount">{Accounts}</span> <i class="fas fa-angle-down"></i></h5>
                                                </div>
                                            </div>
                                        </a>

                                        {!IsLogin &&
                                            <div class="menu-subs dropdown-menu menu-small" id="IsLogin">
                                                <ul class="MA_DD">
                                                    <li id="Dashboard">
                                                        <a itemprop="url" href="/myaccount">
                                                            <span>POS/Employee Login</span>

                                                        </a>
                                                    </li>
                                                    <li id="CustomerLogin">
                                                        <a itemprop="url" href="/customers">
                                                            <span>Customer Login</span>
                                                        </a>
                                                    </li>

                                                    {/*<li id="CorporateLogin">*/}
                                                    {/*    <a itemprop="url" href="/">*/}
                                                    {/*        Corporate User*/}
                                                    {/*    </a>*/}
                                                    {/*</li>*/}
                                                </ul>
                                            </div>
                                        }

                                    </div>

                                    {(Udata.roleID === 29 || Udata.roleID === 32) &&
                                        <li class="AllianceLogo" id="AllianceLogo">
                                            <a href="/">
                                                <img src={CoockieData.AlianceLogo} alt="" />
                                            </a>
                                        </li>
                                    }

                                    <button class="MobileNavBTN" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar2" aria-controls="offcanvasNavbar2">
                                        <span></span>
                                    </button>
                                </div>
                            }
                            {/*<div className="header-item-right">*/}
                            {/*    <ul class="SubHead_Risk" id="headerAlliance">*/}
                            {/*        <li class="CustomerLogin">*/}
                            {/*            <a itemprop="url" href="/customers">*/}
                            {/*                <span id="CustomerID">Customer Login</span>*/}
                            {/*            </a>*/}
                            {/*        </li>*/}
                            {/*        */}{/*{props.DashBoardHide ?*/}
                            {/*        */}{/*    <li>*/}
                            {/*        */}{/*        <a itemprop="url" href="https://www.smcinsurance.com/myaccount">*/}
                            {/*        */}{/*            <button className={`btn SMCSmall  LoginBtn NotMobile ${props.UserLogin ? "DashboardBtn" : ""}`} >*/}
                            {/*        */}{/*                {!props.UserLogin ? "Login" : "Dashboard"}*/}
                            {/*        */}{/*            </button>*/}
                            {/*        */}{/*        </a>*/}
                            {/*        */}{/*        <a itemprop="url" href="https://www.smcinsurance.com/myaccount">*/}
                            {/*        */}{/*            <button className={`btn SMCSmall  LoginBtn ForMobile ${props.UserLogin ? "DashboardBtn" : ""}`} >*/}
                            {/*        */}{/*                <i className={props.UserLogin ? "fas fa-user-circle" : "far fa-user-circle"}></i>*/}
                            {/*        */}{/*            </button>*/}
                            {/*        */}{/*        </a>*/}
                            {/*        */}{/*    </li>*/}
                            {/*        */}{/*    :*/}
                            {/*        */}{/*    null*/}
                            {/*        */}{/*}*/}

                            {/*    </ul>*/}
                            {/*    <button className="navbar-toggler MobileNavBTN" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar2" aria-controls="offcanvasNavbar2">*/}
                            {/*        <span className="navbar-toggler-icon"></span>*/}
                            {/*    </button>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </nav>
            </header>
        </React.Fragment>
    );
}

